import { MARKETS, EDUCATION } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

export const Markets = () => (
  <section className="bg-white py-20 lg:py-32" data-testid="markets-section">
    <Container>
      <Overline>Mercados</Overline>
      <MaskText className="font-display mt-6 max-w-4xl text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-5xl"
        lines={["Experiência construída", <>em diferentes <span className="text-[#1238CE]">mercados.</span></>]} />
      <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-[24px] border border-slate-200 bg-slate-200 md:grid-cols-4">
        {MARKETS.map((m, i) => (
          <Reveal key={m} delay={(i % 4) * 0.06} className="h-full">
            <div className="group relative flex h-full min-h-[140px] flex-col justify-between overflow-hidden bg-white p-6 sm:min-h-[170px]" data-testid={`market-${i}`}>
              <span className="absolute inset-0 translate-y-full bg-[#060B19] transition-transform duration-500 ease-out group-hover:translate-y-0" />
              <span className="font-mono-x relative text-xs text-slate-500 transition-colors group-hover:text-[#CCFF00]">0{i + 1}</span>
              <span className="font-display relative text-xl font-semibold text-[#0F172A] transition-colors group-hover:text-white sm:text-2xl">{m}</span>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-24 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <MaskText className="font-display text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-4xl"
            lines={["Bagagem teórica", "aplicada com rigor", <span className="text-[#1238CE]">pragmático.</span>]} />
          <Reveal><p className="mt-6 max-w-sm text-base leading-relaxed text-slate-600">A teoria é a base do conhecimento, mas é a prática que valida e entrega resultados.</p></Reveal>
        </div>
        <div className="lg:col-span-7">
          <div className="font-mono-x grid grid-cols-2 border-b border-slate-200 pb-3 text-xs uppercase tracking-[0.2em] text-slate-500">
            <span>Formação</span><span>Área</span>
          </div>
          {EDUCATION.map((e, i) => (
            <Reveal key={i} delay={i * 0.06} className="grid grid-cols-2 gap-4 border-b border-slate-200 py-5">
              <span className="text-sm font-bold text-[#0F172A] sm:text-base">{e.k}</span>
              <span className="text-sm text-slate-600 sm:text-base">{e.v}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </Container>
  </section>
);
